import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainPage from './Components/MainPage/MainPage';
import MainAboutUs from './Components/AboutUs/MainAboutUs';
import ContactUs from './Components/ContactUs/ContactUs';
import Tnc from './Components/Policy/Tnc';
import Pnp from './Components/Policy/Pnp';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/about-us" element={<MainAboutUs />} />
          <Route path="/support" element={<ContactUs />} />
          <Route path="/tnc" element={<Tnc />} />
          <Route path="/privacy-policy" element={<Pnp />} />
          {/* Add more routes here as needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
